import React, { useEffect, useState } from 'react'
import './App.css'
import './TicketRefund.css'
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoTicketOutline,
  IoInformationCircleOutline,
  IoWarningOutline,
  IoShieldCheckmarkOutline,
} from 'react-icons/io5'
import ClipLoader from 'react-spinners/ClipLoader'
import ReactTooltip from 'react-tooltip'
import SideNavCust from './layouts/SideNavCust'
import { BiMenu } from 'react-icons/bi'
import Header from './layouts/Header'
import { API_URL } from './config'

const TicketRefund = () => {
  const history = useHistory()
  const [successError, setSuccessError] = useState()
  const [errorDisplay, setErrorDisplay] = useState()
  const [error, setError] = useState()
  const [feedback, setFeedback] = useState()
  const [acknowledge, setAcknowledge] = useState(false)
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [subLoading, setSubLoading] = useState(false)
  const [saveBtn, setSaveBtn] = useState('warning-btn')
  const [saveSubBtn, setSaveSubBtn] = useState('save-btn')
  const [subDisabled, setSubDisabled] = useState(false)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const location = useLocation()
  //   const navigate = useNavigate();
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const {
    ticket_id,
    ticket_number,
    event_name,
    event_id,
    refund_status,
    m_payment_id,
    refund_attempts,
    maxAttempts,
  } = location.state || {}

  const [refundReason, setRefundReason] = useState('')
  const [userNotes, setUserNotes] = useState('')
  const [statusMessage, setStatusMessage] = useState('')
  const [daysLeft, setDaysLeft] = useState(0)
  const [amountRefunded, setAmountRefunded] = useState(0)
  const [originalAmount, setOriginalAmount] = useState(0)
  const [bookingFee, setBookingFee] = useState(0)
  const [netAmount, setNetAmount] = useState(0)
  const [refundFee, setRefundFee] = useState(0)
  const [admission, setAdmission] = useState(0)
  const [refundStatus, setRefundStatus] = useState(refund_status)
  const [refundRulesConfigured, setRefundRulesConfigured] = useState(0)
  const [calLoading, setCalLoading] = useState(true)
  const [postponedCancelled, setPostponedCancelled] = useState('no')
  const [eventPassed, setEventPassed] = useState('no')

  const customer_id = localStorage.getItem('customerid')

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = `${event_name || 'Ticket'} - Refund Request`

    Axios.get(
      `${baseURL}?query=CALCULATE-REFUND&event_id=${event_id}&ticket_id=${ticket_id}&ticket_number=${ticket_number}&customer_id=${customer_id}&m_payment_id=${m_payment_id}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        setDaysLeft(response.data.days_left)
        setRefundFee(response.data.refund_fee)
        setAmountRefunded(response.data.amount_refunded)
        setAdmission(response.data.admission)
        setOriginalAmount(response.data.orginal_amount)
        setBookingFee(response.data.booking_fee)
        setNetAmount(response.data.net_amount)
        setRefundRulesConfigured(response.data.refundRulesConfigured)
        setPostponedCancelled(response.data.postponedCancelled)
        setEventPassed(response.data.event_passed)

        setTimeout(() => {
          setCalLoading(false)
        }, 1000)
      })
      .catch((error) => {
        console.log(error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [event_name, count]) // empty dependency array = run once on mount

  const handleSubmit = (request) => {
    if (refundReason.trim() === '' && refundStatus !== 'Pending') {
      setErrorDisplay('block')
      setError('Please provide a reason for your refund request.')
      setSuccessError('error-login')

      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
      return
    }

    if (request === 'cancel_request') {
      setSaveBtn('btn-disabled')
      setDisabled(true)
      setLoading(true)
    } else {
      setSaveSubBtn('btn-disabled')
      setSubDisabled(true)
      setSubLoading(true)
    }

    const formData = new FormData()
    formData.append('ticket_id', ticket_id)
    formData.append('ticket_number', ticket_number)
    formData.append('refund_reason', refundReason)
    formData.append('userNotes', userNotes)
    formData.append('customer_id', customer_id)
    formData.append('event_id', event_id)
    formData.append('refund_status', refundStatus)
    formData.append('m_payment_id', m_payment_id)

    formData.append('refundFee', refundFee)
    formData.append('daysLeft', daysLeft)
    formData.append('bookingFee', bookingFee)
    formData.append('estimatedRefund', amountRefunded)
    formData.append('originalAmount', originalAmount)
    formData.append('query', 'REQUEST-TICKET-REFUND')

    try {
      Axios({
        url: baseURL,
        method: 'POST',
        data: formData,
        withCredentials: true,
      }).then((response) => {
        setErrorDisplay('block')
        if (response.data.status === 'success') {
          setError(response.data.message)
          setSuccessError('success-login')
          if (refundStatus === 'Pending') {
            setRefundStatus('Cancelled')
          }
          // else {
          //   setRefundStatus("Pending");
          //   setSaveBtn("warning-btn");
          // }
          setCount(count + 1)

          // setSaveBtn("warning-btn");
          // setDisabled(false);
          setLoading(false)

          // setSaveSubBtn("save-btn");
          // setSubDisabled(false);
          setSubLoading(false)
          setAcknowledge(false)
        } else {
          if (response.data.code === 'BANK_DETAILS_NOT_FOUND') {
            setTimeout(() => {
              history.push({
                pathname: '/b-details',
                state: {
                  responseMessage: response.data.message,
                  responseCode: response.data.code,
                  bankList: response.data.bank_name,
                },
              })
            }, 4000)
          }
          setSaveBtn('warning-btn')
          setDisabled(false)
          setLoading(false)

          setSaveSubBtn('save-btn')
          setSubDisabled(false)
          setSubLoading(false)

          setError(<label className="mb-0">{response.data.message}</label>)
          setSuccessError('error-login')
        }

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
        // console.log(response.data);
      })
    } catch (error) {
      setError(error)
      setErrorDisplay('block')
      setSuccessError('error-login')
      setSaveBtn('warning-btn')
      setDisabled(false)
      setLoading(false)

      setSaveSubBtn('save-btn')
      setSubDisabled(false)
      setSubLoading(false)
    }
  }

  const handleReasonChange = (e) => {
    const selected = e.target.value
    setRefundReason(selected)
  }

  const handleNotesChange = (e) => {
    const noteText = e.target.value
    setUserNotes(noteText)
  }

  const handleAcknowledge = () => {
    if (acknowledge) {
      setAcknowledge(false)
    } else {
      setAcknowledge(true)
    }
  }

  let { accountname, dashboard } = ''
  if (localStorage.getItem('customername') === null) {
    if (localStorage.getItem('businessname') === null) {
      if (localStorage.getItem('partnername') === null) {
        return <Redirect to="/login" />
      } else {
        accountname = localStorage.getItem('partnername')
        dashboard = 'in'
      }
    } else {
      accountname = localStorage.getItem('businessname')
      dashboard = 'dashboard'
    }
  } else {
    accountname = localStorage.getItem('customername')
    dashboard = 'customerdashboard'
  }
  const customername = accountname

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  const submitOff = amountRefunded <= 0 || !acknowledge || saveSubBtn === 'btn-disabled'

  // past events can't be refunded unless the event was postponed or cancelled
  const pastEventBlocked = eventPassed === 'yes' && postponedCancelled !== 'yes'

  return (
    <div className="view">
      <Header />
      <SideNavCust collapsed={collapsed} onToggle={handleToggle} />

      {/* ✅ Mobile overlay when sidebar is open */}
      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="rf-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="rf-container">
          <div className="rf-top">
            <button type="button" className="rf-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            {refundStatus === 'Pending' && (
              <button
                type="button"
                className={`rf-btn ${saveBtn === 'btn-disabled' ? 'rf-btn--off' : 'rf-btn--warn'}`}
                onClick={() => handleSubmit('cancel_request')}
                disabled={disabled}
              >
                {!loading ? 'Cancel Request' : ''}
                {loading ? <ClipLoader size={20} color={'#333'} loading={true} /> : ''}
              </button>
            )}
          </div>

          {calLoading ? (
            <section className="rf-card rf-card--loading">
              <ClipLoader size={25} color="grey" />
            </section>
          ) : (
            <section className="rf-card">
              <div className="rf-head">
                <div>
                  <h1>Request refund</h1>
                  {event_name && <p>{event_name}</p>}
                </div>
                <span className="rf-chip">
                  <IoTicketOutline size={14} />
                  {ticket_number}
                </span>
              </div>

              {amountRefunded <= 0 || pastEventBlocked ? (
                <div className="rf-section">
                  <div className="rf-alert rf-alert--warn">
                    <IoWarningOutline size={20} />
                    {pastEventBlocked ? (
                      <p>
                        <strong>This event has already taken place.</strong> Refunds can't be
                        requested after the event. Please contact the organiser directly if
                        exceptional circumstances apply.
                      </p>
                    ) : Number(daysLeft) > 0 && Number(refundFee) > 0 ? (
                      <p>
                        <strong>No refund is available for this ticket.</strong> With {daysLeft}{' '}
                        {Number(daysLeft) === 1 ? 'day' : 'days'} until the event, the refund fee of
                        R{refundFee} is equal to or more than the refundable amount of R{netAmount}{' '}
                        (booking fees are non-refundable). Please contact the organiser directly if
                        exceptional circumstances apply.
                      </p>
                    ) : Number(daysLeft) > 0 ? (
                      <p>
                        <strong>Refunds are no longer available for this ticket.</strong> The refund
                        rules for this event don't allow a refund {daysLeft}{' '}
                        {Number(daysLeft) === 1 ? 'day' : 'days'} before the event. Please contact
                        the organiser directly if exceptional circumstances apply.
                      </p>
                    ) : (
                      <p>
                        Refunds are <strong>not permitted on the day of the event</strong>. This
                        policy helps ensure fairness to organisers and accounts for non-refundable
                        operational costs already committed. We appreciate your understanding and
                        encourage you to contact the organiser directly if exceptional circumstances
                        apply.
                      </p>
                    )}
                  </div>
                </div>
              ) : (
                <>
                  {refund_attempts === maxAttempts && (
                    <div className="rf-section">
                      <div className="rf-alert rf-alert--warn">
                        <IoWarningOutline size={20} />
                        <p>
                          You've reached the maximum of {maxAttempts} refund attempts. No further
                          requests allowed.
                        </p>
                      </div>
                    </div>
                  )}

                  {refund_attempts === maxAttempts ? null : (
                    <div>
                      {refundStatus === 'Pending' ? (
                        <div className="rf-section">
                          <div className="rf-status">
                            <span>Current status</span>
                            <strong>{refundStatus}</strong>
                          </div>
                          <p className="rf-text">
                            Your refund request is currently under review. We're processing it as
                            quickly as possible and will notify you once there's an update. If you'd
                            like to cancel this request, you're welcome to do so at any time.
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="rf-section">
                            <label htmlFor="reason" className="rf-label">
                              Reason for refund
                            </label>
                            <select
                              id="reason"
                              value={refundReason}
                              onChange={handleReasonChange}
                              required
                              className="rf-select"
                            >
                              <option value="">Select a reason</option>

                              <optgroup label="Event-Related">
                                <option value="event_cancelled">Event was cancelled</option>
                                <option value="event_rescheduled">Event was rescheduled</option>
                                <option value="performer_changed">
                                  Performer or headliner changed
                                </option>
                              </optgroup>

                              <optgroup label="Personal Circumstances">
                                <option value="cant_attend">I can't attend anymore</option>
                                <option value="wrong_ticket">I bought the wrong ticket type</option>
                                <option value="mistaken_purchase">
                                  I bought tickets by mistake
                                </option>
                              </optgroup>

                              <optgroup label="Technical Issues">
                                <option value="no_confirmation">
                                  Didn't receive ticket confirmation
                                </option>
                                <option value="duplicate_payment">
                                  Duplicate charge or booking
                                </option>
                                <option value="payment_error">Payment or booking issue</option>
                              </optgroup>

                              <option value="other">Other (please specify)</option>
                            </select>

                            <label className="rf-label rf-label--spaced">
                              Additional comments <span>(optional)</span>
                            </label>
                            <textarea
                              placeholder="Type here..."
                              onChange={handleNotesChange}
                              className="rf-textarea"
                              rows={4}
                            />
                          </div>

                          <div className="rf-section">
                            <div className="rf-policy">
                              <div className="rf-policy__title">
                                <IoShieldCheckmarkOutline size={18} />
                                <span>
                                  Refund Policy:{' '}
                                  {postponedCancelled === 'yes'
                                    ? 'Karamale Default Rules'
                                    : refundRulesConfigured === 'yes'
                                      ? "Organizer's Rules"
                                      : 'Karamale Default Rules'}
                                </span>
                              </div>

                              {postponedCancelled === 'yes' ? (
                                <p className="rf-policy__notice">
                                  This event has been postponed or cancelled. Refunds will be issued
                                  in full, minus the booking fee.
                                </p>
                              ) : (
                                ''
                              )}

                              <p
                                className={
                                  refundRulesConfigured === 'yes' ? 'd-none' : 'rf-policy__text'
                                }
                              >
                                Refund requests submitted within 3 days of the event will incur a{' '}
                                <strong>R15 + 25%</strong> processing fee and admin cost or be
                                declined per{' '}
                                <Link to={'/refund-policy'} target="_blank">
                                  Karamale refund policy.
                                </Link>
                              </p>

                              <dl className="rf-breakdown">
                                <div>
                                  <dt>Original transaction</dt>
                                  <dd>R{originalAmount}</dd>
                                </div>
                                <div>
                                  <dt>
                                    Booking fee (non-refundable){' '}
                                    <span
                                      className="rf-info"
                                      data-tip={`${
                                        refundRulesConfigured === 'yes'
                                          ? 'This fee helps the organizer cover event-related costs such as venue deposits or upfront expenses.'
                                          : 'This fee covers platform operations and payment processing.'
                                      } ${
                                        refundRulesConfigured === 'yes'
                                          ? 'It is not refundable.'
                                          : 'It is retained by Karamale and is not refundable.'
                                      } `}
                                      data-effect="solid"
                                      data-arrow-color="transparent"
                                      data-type="dark"
                                      data-place="top"
                                    >
                                      ℹ️
                                      <ReactTooltip />
                                    </span>
                                  </dt>
                                  <dd>R{bookingFee}</dd>
                                </div>
                                <div>
                                  <dt>Refundable amount</dt>
                                  <dd>R{netAmount}</dd>
                                </div>
                                <div>
                                  <dt>Refund request timing</dt>
                                  <dd>{daysLeft} days before the event</dd>
                                </div>
                                <div>
                                  <dt>
                                    {refundRulesConfigured === 'no' ? 'Karamale' : 'Organizer'}{' '}
                                    refund deduction
                                  </dt>
                                  <dd>R{refundFee}</dd>
                                </div>
                                <div>
                                  <dt>Admissions</dt>
                                  <dd>{admission}</dd>
                                </div>
                                <div className="rf-breakdown__total">
                                  <dt>Estimated refund</dt>
                                  <dd>R{amountRefunded}</dd>
                                </div>
                              </dl>
                            </div>

                            <label htmlFor="checkbox" className="rf-check">
                              <input type="checkbox" id="checkbox" onChange={handleAcknowledge} />
                              <span>
                                I acknowledge and understand the information provided above.
                              </span>
                            </label>
                          </div>

                          <div className="rf-foot">
                            <button
                              type="button"
                              disabled={subDisabled}
                              className={`rf-btn ${submitOff ? 'rf-btn--off' : 'rf-btn--primary'}`}
                              onClick={
                                amountRefunded <= 0
                                  ? ''
                                  : !acknowledge
                                    ? () =>
                                        alert(
                                          'Please indicate if you acknowledge and understand the refund policy. Scroll to the bottom.',
                                        )
                                    : () => handleSubmit('submit_request')
                              }
                            >
                              {!subLoading ? 'Submit' : ''}
                              {subLoading ? (
                                <ClipLoader size={20} color={'#333'} loading={true} />
                              ) : (
                                ''
                              )}
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </section>
          )}
        </div>
      </main>

      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
    </div>
  )
}

export default TicketRefund
